import { Injectable } from '@angular/core';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private appService:AppService) { }

  isLoggedIn(): boolean {
    return !!sessionStorage.getItem('user-data');  // Check if there's a token stored
  }

  login(token: string): void {
    this.appService.onCheckSetItem(true);
    sessionStorage.setItem('user-data', token);
  }

  logout(): void {
    sessionStorage.removeItem('user-data');
  }

}
